import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ca23364c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ca23364c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca23364c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca23364c')) {
      api.createRecord('ca23364c', component.options)
    } else {
      api.reload('ca23364c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ca23364c&scoped=true", function () {
      api.rerender('ca23364c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/fieldLibrary/index.vue"
export default component.exports